import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function VendorContracts() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Vendor & Supplier Commercial Outcomes - Negotrix | 15-25% Improvement';
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`min-h-screen bg-cipher-black text-white transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Header />

      {/* Hero */}
      <section className="pt-40 pb-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-6">Cost Category</h2>
          <h1 className="text-[8vw] leading-[0.9] font-black tracking-tighter mb-12">
            <span className="text-white">Vendor</span><br />
            <span className="text-cipher-hypergreen">Contracts.</span>
          </h1>
          <div className="flex items-center gap-6 mb-10">
            <div className="text-5xl font-black text-cipher-hypergreen">15–25%</div>
              <div className="text-gray-400 text-xl">average improvement on<br />vendor agreements</div>
          </div>
          <p className="text-xl text-gray-400 max-w-2xl">
            Renegotiate terms, consolidate suppliers, and leverage benchmarking data for better vendor agreements across your entire supply chain.
          </p>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-24 bg-cipher-dark border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-16">What We Do</h2>
          <div className="border-t border-gray-800">
            {[
              { title: 'Contract Analysis & Benchmarking', desc: 'We analyze your existing vendor contracts and benchmark them against our proprietary database of current market rates to identify pricing disparities and unfavorable terms.' },
              { title: 'Supplier Consolidation', desc: 'We identify opportunities to consolidate spending with fewer vendors, unlocking volume discounts and reducing administrative overhead.' },
              { title: 'Negotiation & Renewal Optimization', desc: 'Our experienced negotiators handle vendor discussions on your behalf, ensuring you get the best possible terms at renewal time.' },
              { title: 'Payment Term Optimization', desc: 'We negotiate extended payment terms to improve your working capital and identify early payment discount opportunities that make financial sense.' },
            ].map((item, i) => (
              <div key={i} className="group border-b border-gray-800 py-12 hover:bg-cipher-black transition-colors px-6 -mx-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
                  <div className="lg:col-span-1 text-gray-600 font-black text-xl">0{i + 1}</div>
                  <div className="lg:col-span-4 text-2xl lg:text-3xl font-black group-hover:text-cipher-hypergreen transition-colors">{item.title}</div>
                  <div className="lg:col-span-7 text-gray-400 text-lg">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 bg-cipher-black border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { val: 'Direct', label: 'Vendor Negotiation' },
              { val: 'No', label: 'Upfront Fees' },
              { val: 'Only', label: 'On Results' }
            ].map((s, i) => (
              <div key={i} className="p-8 bg-cipher-dark rounded-[2rem] border border-gray-800">
                <div className="text-5xl lg:text-6xl font-black text-cipher-hypergreen mb-4">{s.val}</div>
                <div className="text-sm tracking-widest uppercase text-gray-500 font-bold">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-32 lg:py-48 bg-cipher-dark border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-[8vw] leading-[0.9] font-black tracking-tighter text-white mb-12">
            Secure better<br /><span className="text-cipher-hypergreen">terms today.</span>
          </h2>
          <button
            onClick={() => navigate('/contact')}
            className="inline-flex items-center justify-center px-10 py-5 text-lg tracking-wide font-bold uppercase rounded-full text-cipher-black bg-cipher-hypergreen hover:bg-white transition-all duration-300"
          >
             Start Your Commercial Review
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
